"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const validatorJS = require("validator");
class IsLowercaseValidator {
    isValid(input) {
        if (typeof input === "undefined" || input === null) {
            return false;
        }
        return validatorJS.isLowercase(input);
    }
}
exports.IsLowercaseValidator = IsLowercaseValidator;
//# sourceMappingURL=IsLowercaseValidator.js.map